import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, sizeTab } from "@/shared";
import {  SingleTableBoxScene } from "@/shared/components/ui"
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import IngresoInventarioOrdenFinalizado from "./consultaIngresoInventarioPage/IngresoInventarioOrdenFinalizadoPage";


const ConsultaOrdenCompraPage = () => {
  const [valueTab, setValueTab] = useState(0)
  return (
    <>
      <SingleTableBoxScene
        title="📊Reporte de Ingreso de Recepción"
      >
        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs solicitud pedidos"
          >
            {/* <Tab label={'Reporte1'} {...a11yProps(0)} /> */}
            <Tab label={'Reporte'} {...a11yProps(0)} />
          </Tabs>
        </Box>
      {/*   <CustomTabPanel value={valueTab} index={0}>
          <IngrseoInventarioFinalizado/>
        </CustomTabPanel> */}
        
        <CustomTabPanel value={valueTab} index={0}>
          <IngresoInventarioOrdenFinalizado/>
        </CustomTabPanel>
      </SingleTableBoxScene>
    </>
  )
}
export default ConsultaOrdenCompraPage;